import styled from 'styled-components'

interface Props {
    editMode: boolean
}

export const UpdateEnvPropertiesContainer = styled.div<Props>`
    @media (min-width: 992px) {
        &.env-properties-container {
            width: 720px;
            width: 940px;
        }
    }
    @media (min-width: 1600px) {
        &.env-properties-container {
            width: 1140px;
        }
    }
    border: 1px solid ${({ theme }) => theme['gray-300']};
    border-radius: 5px;
    
    .title {
        background: ${props => (props.editMode ? ({ theme }) => theme['gray-200'] : 'transparent')};
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 12px 0 24px;
        border-bottom: 1px solid ${({ theme }) => theme['gray-300']};
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 600;

        button {
            border: none;
            background: transparent;
            color: ${({ theme }) => theme['blue-500']};
        }
    }

    .header {
        display: flex;
        border-bottom: 1px solid ${({ theme }) => theme['gray-300']};
        align-items: center;
        background: ${({ theme }) => theme['gray-100']};

        div {
            width: 50%;
            padding: 12px 24px;
            font-size: 14px;
            font-weight: 600;
        }

        div + div {
            border-left: 1px solid ${({ theme }) => theme['gray-300']};
        }
    }

    .newVariable {
        width: 100%;
        height: 44px;
        font-size: 15px;
        border: none;
        background-color: ${({ theme }) => theme['blue-200']};
        border-bottom: 1px solid ${({ theme }) => theme['gray-300']};
    }

    .generated-input {
        display: flex;
        border-bottom: 1px solid ${({ theme }) => theme['gray-300']};
        align-items: center;
        background: ${({ theme }) => theme['gray-0']};

        input {
            width: 50%;
            padding: 12px 24px;
            font-size: 13px;
            border: none;
            background: transparent;
        }

        input + input {
            border-left: 1px solid ${({ theme }) => theme['gray-300']};
            /* width: calc(50% - 44px); */
            width: ${props => props.editMode ? 'calc(50% - 44px)' : '50%'};
        }

        .delete {
            background: ${({ theme }) => theme['gray-0']};
            color: ${({ theme }) => theme['red-700']};
            border: none;
            border-left: 1px solid ${({ theme }) => theme['gray-300']};
            height: 44px;
            width: 44px;
        }
    }
`

export const UpdateEnvPropertiesSaveBar = styled.div`
    width: 100%;
    padding: 10px 20px;
    background: ${({ theme }) => theme['gray-200']};
    width: 100%;
    button {
        width: 90px;
        //height: 32px;
        border-radius: 3px;
        margin-right: 8px;
    }

    .save {
        border: 1px solid;
        border-color: ${({ theme }) => theme['blue-500']};
        background: ${({ theme }) => theme['blue-500']};
        color: ${({ theme }) => theme['gray-100']};
    }
    .cancel {
        border: 1px solid;
        border-color: ${({ theme }) => theme['gray-500']};
        background: transparent;
        color: ${({ theme }) => theme['gray-800']};
        margin-left: 8px;
    }
`
